import { useFilter } from '../../contexts/FilterContext';
import { useConfig } from '../../contexts/ConfigContext';
import { filterTypes } from '../../config';

const SpecialsToggle = ({ deviceType = 'desktop' }) => {
    const { 
        selectedFilters,
        handleFilterChange,
    } = useFilter();
    
    const { menuConfig = {} } = useConfig();
    const { specialsName } = menuConfig;
    const safeSpecialsName = specialsName || 'Deals';
    const toggleId = `specials-toggle-${deviceType}`;

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleFilterChange({ value: 'specials' }, filterTypes.category);
        }
    };

    return (
        <div className="specials-toggle-wrapper">
            <label 
                className="toggle-switch-label" 
                htmlFor={toggleId}
            >
                <span className="toggle-label-text">Show {safeSpecialsName.toLowerCase()}</span>
                <div className="headless-toggle-box">
                    <input
                        className="tgl tgl-ios"
                        id={toggleId}
                        type="checkbox"
                        value="specials"
                        checked={Boolean(selectedFilters.specials)}
                        onChange={(e) => handleFilterChange(e.target, filterTypes.category)}
                        onKeyPress={handleKeyPress}
                    />
                    <span 
                        className="tgl-btn"
                        aria-hidden="true"
                    />
                </div>
            </label>
        </div>
    );
};

export default SpecialsToggle;
